import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
// ----------------------------------------------------------------------

type InputValue = Date | string | number | null | undefined;

export function fDate(date: InputValue, newFormat?: string) {
  const format = newFormat || 'DD MMM YYYY'; // Note the format change to match dayjs syntax

  return date ? dayjs(date).format(format) : '';
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const format = newFormat || 'DD MMM YYYY h:mm A'; // Adjusted to match dayjs format tokens

  return date ? dayjs(date).format(format) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? dayjs(date).valueOf() : ''; // `valueOf` gives you the timestamp
}

export function fToNow(date: InputValue) {
  return date
    ? dayjs(date).fromNow() // Simpler and directly supported with the relativeTime plugin
    : '';
}
